import { render } from "./Set-General.vue?vue&type=template&id=43e37f74"
import script from "./Set-General.vue?vue&type=script&lang=js"
export * from "./Set-General.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__